import { render, staticRenderFns } from "./scientific-analysis-search-tab-templates.vue?vue&type=template&id=5d146bee&"
import script from "./scientific-analysis-search-tab-templates.ts?vue&type=script&lang=ts&"
export * from "./scientific-analysis-search-tab-templates.ts?vue&type=script&lang=ts&"
import style0 from "./scientific-analysis-search-tab-templates.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports